import {TheRaveSymbol} from "./TheRaveSymbol";
import {TheRaveSymbolState} from "./TheRaveSymbolConfig";
import {TimelineLite} from "gsap";
import {TheRave} from "../TheRave";
import {TheRaveSound} from "../sound/TheRaveSound";
import {FontStyleConfig} from "../config/FontConfig";

export class TheRaveWildSymbol extends TheRaveSymbol {

    private _symbolSpine:PIXI.spine.Spine;
    private _symbolSpineBlend:PIXI.spine.Spine;
    private _symbolSpineTop:PIXI.spine.Spine;

    protected numberBmps: PIXI.BitmapText [] = [];

    constructor(symbolName: string, reelId: number, initState: TheRaveSymbolState, symHeight: number = 150, linkedNum: number = 1, fullWild:boolean = false) {
        super(symbolName, reelId, initState,symHeight, linkedNum, fullWild);

        if(fullWild) {
            // Add mp values
            const bmps:PIXI.BitmapText [] = this.createNumbers(this.height);
            bmps.forEach((txt) => {
                txt.visible = false;
                this.addChild(txt);
                this.numberBmps.push(txt);
            })
        }
    }

    public  showMultiplier(symbolSize:number):void {
        let numberSprite:PIXI.BitmapText;
        this.curMpValue = symbolSize;

        if(this.numberBmps.length < 1) {
            const bmps:PIXI.BitmapText [] = this.createNumbers(this.height);
            bmps.forEach((txt) => {
                txt.visible = false;
                this.addChild(txt);
                this.numberBmps.push(txt);
            });
        }

        this.numberBmps.forEach((sprite:PIXI.BitmapText) => {
            //debugger;
            if(sprite.text === "x" + symbolSize){
                numberSprite = sprite;
                numberSprite.visible = true;
            }
            //console.log(sprite.name, "x" + symbolSize)
        });
    }

    public hideAllMultipliers():void {

        this.numberBmps.forEach((sprite:PIXI.BitmapText) => {
            //debugger;
            sprite.visible = false;
            //console.log(sprite.name, "x" + symbolSize)
        });
    }

    private createNumbers(wrapperHeight:number):PIXI.BitmapText [] {
        const bmps:PIXI.BitmapText [] = [];

        ["x6", "x7", "x8", "x9", "x10", "x11"].forEach((txt) => {
            const bmpText = new PIXI.BitmapText(txt, FontStyleConfig.SYMBOL_MULTIPLIER);
            bmpText.name = txt;
            //(<PIXI.Point>bmpText.anchor).set(1.5, 1);
            //bmpText.scale.set(0.4);
            bmpText.x = -60.5;
            bmpText.y = 129;//wrapperHeight - bmpText.height;
            bmpText.letterSpacing = -8;
            bmpText.visible = false;
            bmps.push(bmpText);
            //bmpText.visible = false;
        });

        // debugger;
        return bmps;
    }

    protected updateLayers() {
        if(this._symbolSpine) {
            this.addChild(this._symbolSpine);
            this.addChild(this._symbolSpineBlend);
            this.addChild(this._symbolSpineTop);
        }

        if(this.curMpValue > 0) {
            this.showMultiplier(this.curMpValue);
        }
    }

    public playLanding(init:boolean = false):TimelineLite {
        const tl = new TimelineLite();
        this.prepareSpine();
        tl.add(
            () => {
                this.updateLayers();
                TheRaveSound.playSoundEffect("wildLanding");
                this._symbolSpine.visible = true;
                this._symbolSpine.state.setAnimation(0, "animation", false);
                this._symbolSpineBlend.visible = true;
                this._symbolSpineBlend.state.setAnimation(0, "animation", false);
                this._symbolSpineTop.visible = true;
                this._symbolSpineTop.state.setAnimation(0, "animation", false);
            }, 0);

        tl.add(() => {
            if(this && this._symbolSpine && this.curMpValue === 0){
                this._symbolSpine.destroy();
                this._symbolSpineBlend.destroy();
                this._symbolSpineTop.destroy();
            }
        }, 0.567);
        return tl;
    }

    private prepareSpine():void {
        if(!this._symbolSpine) {
            this._symbolSpine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`wildNORMAL`));
            this._symbolSpine.name = "wildNORMAL";
            this._symbolSpine.autoUpdate = true;
            this._symbolSpine.position.set(0, 0);
            this._symbolSpine.visible = false;
            this._symbolSpineTop = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`wildNORMALTOP`));
            this._symbolSpineTop.name = "wildNORMALTOP";
            this._symbolSpineTop.autoUpdate = true;
            this._symbolSpineTop.position.set(0, 0);
            this._symbolSpineTop.visible = false;
            this._symbolSpineBlend = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`wildBLEND`));
            this._symbolSpineBlend.name = "wildBLEND";
            this._symbolSpineBlend.autoUpdate = true;
            this._symbolSpineBlend.position.set(0, 0);
            this._symbolSpineBlend.visible = false;
        }
    }
}